/**
 * Created by AlexanderC on 3/7/16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loader = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _KernelDriver = require('./Driver/KernelDriver');

var _AsyncConfig = require('./Driver/AsyncConfig');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

let Loader = exports.Loader = function () {
  /**
   * @param {AbstractDriver|FsDriver|HttpDriver|KernelDriver|ComplexDriver|*} driver
   */
  function Loader() {
    let driver = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    _classCallCheck(this, Loader);

    this._driver = driver;
  }

  /**
   * @param {Kernel|*} kernel
   * @returns {Loader}
   */


  _createClass(Loader, [{
    key: 'setDriver',


    /**
     * @param {AbstractDriver|FsDriver|HttpDriver|KernelDriver|ComplexDriver|*} driver
     * @returns {Loader}
     */
    value: function setDriver(driver) {
      this._driver = driver;

      return this;
    }

    /**
     * @param {Function} onLoaded
     * @param {Function} onFail
     */

  }, {
    key: 'load',
    value: function load() {
      let onLoaded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : () => {};
      let onFail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};

      onLoaded && this._driver.onLoadedCb(onLoaded);
      onFail && this._driver.onFailCb(onFail);

      this._driver.load();
    }
  }, {
    key: 'driver',


    /**
     * @returns {AbstractDriver|FsDriver|HttpDriver|KernelDriver|ComplexDriver|*}
     */
    get: function get() {
      return this._driver;
    }
  }], [{
    key: 'asyncConfigLoader',
    value: function asyncConfigLoader(kernel) {
      return new Loader(new _AsyncConfig.AsyncConfig(kernel));
    }

    /**
     * @param {Kernel|*} kernel
     * @returns {Loader}
     */

  }, {
    key: 'kernelLoader',
    value: function kernelLoader(kernel) {
      return new Loader(new _KernelDriver.KernelDriver(kernel));
    }
  }]);

  return Loader;
}();


//////////////////
// WEBPACK FOOTER
// ../~/deep-kernel/lib.compiled/Config/Loader.js
// module id = 391
// module chunks = 0